// import React, { useState } from 'react';


// const WebPagePdf = () => {
//   const pdfUrl = 'https://caisdatahouse.blob.core.windows.net/insurance-inspection/downloadedPdf/FWDI18144814.pdf?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D'; 

//   return (
//     <div style={{ height: '100vh' }}>
//       <embed
//         src={pdfUrl}
//         type="application/pdf"
//         width="100%"
//         height="100%"
//       />
//     </div>
//   );
// };
// export default WebPagePdf;


import React from 'react';

const WebPagePdf = () => {
  const pdfUrl = 'https://caisdatahouse.blob.core.windows.net/insurance-inspection/downloadedPdf/FWDI18144814.pdf?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D';

  return (
    <div style={{ height: '100vh' }}>
      <iframe
        src={`https://docs.google.com/gview?url=${pdfUrl}&embedded=true`}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        title="PDF Viewer"
      />
    </div>
  );
};

export default WebPagePdf;
